/* ============================================================================
   Metal category page — rail behaviour. Everything else on the page is static
   markup rendered by Liquid, which is the point: fourteen collection rows drawn
   from the live store need no client-side data layer, and a page that renders
   without JavaScript is a page that renders.

   Two jobs only:
     1. clicking a pill scrolls to its row and keeps the pill in view,
     2. the pill for the row you are looking at is the one that reads active.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- FAQ accordion + scroll reveals ----
     Both normally arrive with ps-collection26.js, and this page does not load it: that
     file's whole job below the reveals is the filterable grid, and a metal page has no
     grid to filter. These two are the parts of it the shared markup does depend on, so
     they are reproduced here rather than pulling in ~900 lines that would then look for
     a window.PS_COLLECTION that does not exist. Same recipe, same class names. */
  document.querySelectorAll('.faq-q').forEach(function (b) {
    b.addEventListener('click', function () {
      var it = b.closest('.faq-item');
      var open = it.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    /* `fx` is what makes [data-rv] start hidden. It is added only here, so with JS off
       or motion reduced the page renders fully visible instead of blank. */
    document.documentElement.classList.add('fx');
    var rv = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.hasAttribute('data-rv-kids')) {
          Array.prototype.forEach.call(el.children, function (kid, i) {
            kid.style.transitionDelay = Math.min(i * 60, 360) + 'ms';
          });
        }
        el.classList.add('in');
        rv.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0% 0% -10% 0%' });
    document.querySelectorAll('[data-rv],[data-rv-kids]').forEach(function (el) { rv.observe(el); });
  }

  var rail = document.querySelector('.mrail');
  if (!rail) return;

  var pills = Array.prototype.slice.call(rail.querySelectorAll('.relpill[href^="#"]'));
  if (!pills.length) return;

  var byId = {};
  pills.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });

  function activate(id) {
    pills.forEach(function (a) { a.classList.toggle('is-active', a === byId[id]); });
    var on = byId[id];
    /* Keep the active pill visible in the rail without moving the page: the rail
       scrolls horizontally on its own, so scrollIntoView on the pill itself
       would drag the whole document sideways on some browsers. */
    if (on && on.parentNode && on.parentNode.scrollWidth > on.parentNode.clientWidth) {
      var row = on.parentNode;
      var want = on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2;
      row.scrollTo({ left: Math.max(0, want), behavior: 'smooth' });
    }
  }

  /* A pill is a real anchor, so the no-JS path already works. This only adds the
     smooth scroll and writes the hash without a jump. */
  pills.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      var row = document.getElementById(id);
      if (!row) return;
      e.preventDefault();
      row.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      activate(id);
    });
  });

  if ('IntersectionObserver' in window) {
    /* The band that decides "the row you are looking at" sits just under the
       sticky rail and stops well above the fold, so a tall row does not hand the
       active state to the next one the moment its heading leaves the screen. */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) activate(en.target.id);
      });
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
    Object.keys(byId).forEach(function (id) {
      var row = document.getElementById(id);
      if (row) io.observe(row);
    });
  }

  if (location.hash && byId[location.hash.slice(1)]) activate(location.hash.slice(1));
})();
